import { useState, useRef, type ReactNode } from 'react';
import { GammaImpact, TotalOIPutCallImpactConfig } from '../../../types';
import { BrushZoomConfig } from '../../../types/shared';
import { DEFAULT_BRUSH_ZOOM_CONFIG } from '../../../config';
import { TotalOIPutCallImpactContext } from './useTotalOIPutCallImpactCtx';

interface TotalOIPutCallImpactProviderProps {
  selectedSym: string;
  config: TotalOIPutCallImpactConfig;
  onConfigChange: (patch: Partial<TotalOIPutCallImpactConfig>) => void;
  children: ReactNode;
}

export const TotalOIPutCallImpactProvider = ({
  selectedSym,
  config,
  onConfigChange,
  children,
}: TotalOIPutCallImpactProviderProps) => {
  const [initialData, setInitialData] = useState<GammaImpact[]>([]);
  const [zoomConfig, setZoomConfig] = useState<BrushZoomConfig>(
    DEFAULT_BRUSH_ZOOM_CONFIG,
  );
  const chartRef = useRef<HTMLDivElement | null>(null);

  return (
    <TotalOIPutCallImpactContext.Provider
      value={{
        selectedSym,
        config,
        updateConfig: onConfigChange,
        initialData,
        setInitialData,
        zoomConfig,
        setZoomConfig,
        chartRef,
      }}
    >
      {children}
    </TotalOIPutCallImpactContext.Provider>
  );
};
